import React, { createContext, useContext, useState, useEffect } from 'react';
import { messageService, MessageStatus } from '../services/messageService';

interface MessageContextType {
  newMessageCount: number;
  updateNewMessageCount: () => Promise<void>;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [newMessageCount, setNewMessageCount] = useState(0);

  const updateNewMessageCount = async () => {
    try {
      const messages = await messageService.getMessages(MessageStatus.NEW);
      setNewMessageCount(messages.length);
    } catch (error) {
      console.error('Error fetching new message count:', error);
    }
  };

  useEffect(() => {
    updateNewMessageCount();
    
    // Update count every 5 minutes
    const interval = setInterval(updateNewMessageCount, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <MessageContext.Provider value={{ newMessageCount, updateNewMessageCount }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessages = () => {
  const context = useContext(MessageContext);
  if (context === undefined) {
    throw new Error('useMessages must be used within a MessageProvider');
  }
  return context;
}; 